import styles from './ProgressRail.module.css';

interface Props {
  total: number;
  index: number;
  /** Сколько азкаров уже дочитано полностью */
  completed: boolean[];
  /** Переход к азкару по номеру */
  onSelect: (i: number) => void;
}

export function ProgressRail({ total, index, completed, onSelect }: Props) {
  return (
    <div
      className={styles.rail}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={index + 1}
    >
      {Array.from({ length: total }, (_, i) => (
        // Сегменты кликабельны: в наборе из 16 азкаров прыгать
        // кнопками «Далее» по одному — долго
        <button
          key={i}
          className={styles.segment}
          data-state={
            completed[i] ? 'done' : i === index ? 'current' : 'pending'
          }
          onClick={() => onSelect(i)}
          aria-label={`Азкар ${i + 1} из ${total}`}
          aria-current={i === index ? 'step' : undefined}
        />
      ))}
    </div>
  );
}
